import Checks from './Checks';
import FieldSet from './FieldSet';
import Parameter from './Parameter';
import ComboBoxField from './Class/ComboBoxField';
import CheckBoxField from './Class/CheckBoxField';
import DateField from './Class/DateField';
import GridPanelField from './Class/GridPanelField';
import NumberField from './Class/NumberField';
import RadioGroupField from './Class/RadioGroupField';
import SpinnerField from './Class/SpinnerField';
import BaseObjectTypeEnum from '@/enums/BaseObjectTypeEnum';
import ReportParameters from './ReportParameters';

export default class Report{

    public ReportId: string;

    public Name: string;

    public Type: string;

    public NodeIds: Number[];

    public NodeTypes: BaseObjectTypeEnum[];

    public Filters: string[];

    public ReportParameters: ReportParameters;

    public ReportDescription: any;

    public IsPublic: boolean | null;

    public constructor(ReportId: string = "1", Name: string = "", Type: string = "", NodeIds: Number[] = [], NodeTypes: BaseObjectTypeEnum[] = [], Filters: string[] = [''], ReportParameters: ReportParameters = undefined, ReportDescription: any = '', IsPublic: boolean | null = null)
    {
        this.ReportId = ReportId;
        this.Name = Name;
        this.Type = Type;
        this.NodeIds = NodeIds;
        this.NodeTypes = NodeTypes;
        this.Filters = Filters;
        this.ReportParameters = ReportParameters;
        this.ReportDescription = ReportDescription;
        this.IsPublic = IsPublic;
    }

    // public fromXml(xml: string){
    //     if(xml){
    //         let parser = new DOMParser();
    //         let xmlDoc = parser.parseFromString(xml, "application/xml");

    //         let xmlReport: Element = xmlDoc.querySelector('Root');
    //         if(xmlReport != null){
    //             this.ReportId = xmlReport.getAttribute('ReportId') || '1';
    //             this.Name = xmlReport.getAttribute('Name') || '';
    //             this.Type = xmlReport.getAttribute('Type') || '';

    //                 if(xmlReport.querySelectorAll('FieldSet')){
    //                 xmlReport.querySelectorAll('FieldSet').forEach((field) => {
    //                     this.FieldSets.push(new FieldSet().fromXml(field.outerHTML));
    //                 });
    //             }
    //         }

    //         return this;
    //     }
    // }
    
    // @Todo : Transforme mon Objet en
    public objectToXml(obj: any = this, rootElement: string = "Root"): string {
        const buildXml = (obj: any, nodeName: string): string => {
            if (typeof obj !== "object" || obj === null) {
                return `<${nodeName}>${obj}</${nodeName}>`;
            }
    
            return `<${nodeName}>${Object.entries(obj)
                .map(([key, value]) => buildXml(value, key))
                .join("")}</${nodeName}>`;
        };
    
        return `${buildXml(obj, rootElement)}`;
    }



    //#region Create Report

    public CreateReport(data: any): Report{
        let ReportParameters: ReportParameters = this.CreateReportParameters(data.ReportParameters)
        return new Report(data.ReportId, data.Name, data.Type, data.NodeIds, data.NodeTypes, data.Filters, ReportParameters, data.ReportDescription, data.IsPublic);
    }

    //#endregion

    //#region Create ReportParameters 

    public CreateReportParameters(data: any): ReportParameters{
        let fieldSets: FieldSet[] = this.CreateFieldSets(data.FieldSets);
        return new ReportParameters(data.DictionaryParameters, fieldSets, data.Checks);
    }

    //#endregion

    //#region Create FieldSets

    private CreateFieldSets(data: any): FieldSet[]{
        let fieldSets: FieldSet[] = [];

        data.forEach(u => {
            let parameter: Parameter[] = this.CreateParameters(u.Parameters);
            fieldSets.push(new FieldSet(u.Title, u.Name, u.Layout, u.Type, u.CheckboxToggle, parameter))
        })
        return fieldSets;
    }

    //#endregion

    //#region Create Parameters

    public CreateParameters(data: any): Parameter[]{
        let parameters: Parameter[] = [];
        data.forEach(u => {
            parameters.push(this.createExtendParameter(u))
        })
        return parameters;
    }

    public createExtendParameter(parameter: any){
        let functionName: string = "create" + parameter.Type;

        if(typeof this[functionName] === 'function')
            return this[functionName](parameter)
        else return parameter;
    }

    private createCheckBox(parameter: any): CheckBoxField {
        if(parameter != null){
            return new CheckBoxField(parameter?.Name, parameter?.Label, parameter?.Type, parameter?.EmptyText, parameter?.Selected, parameter?.Option, parameter?.Listeners);
        }
        return null;
    }

    private createComboBox(parameter: any): ComboBoxField {
        if(parameter != null){
            return new ComboBoxField(parameter?.Name, parameter?.Label, parameter?.Type, parameter?.EmptyText, parameter?.Selected, parameter?.Option, parameter?.Listeners, parameter?.Data, parameter?.Value, parameter?.Options);
        }
        return null;
    }

    private createDateField(parameter: any): DateField {
        if(parameter != null){
            return new DateField(parameter?.Name, parameter?.Label, parameter?.Type, parameter?.EmptyText, parameter?.Selected, parameter?.Option, parameter?.Listeners, parameter?.Min, parameter?.Max);
        }
        return null;
    }

    private createGridPanel(parameter: any): GridPanelField {
        if(parameter != null){
            return new GridPanelField(parameter?.Name, parameter?.Label, parameter?.Type, parameter?.EmptyText, parameter?.Selected, parameter?.Option, parameter?.Listeners, parameter?.Data, parameter?.Options, parameter?.PageSize);
        }
        return null;
    }

    private createNumber(parameter: any): NumberField {
        if(parameter != null){
            return new NumberField(parameter?.Name, parameter?.Label, parameter?.Type, parameter?.EmptyText, parameter?.Selected, parameter?.Option, parameter?.Listeners, parameter?.Step);
        }
        return null;
    }

    private createRadioGroup(parameter: any): RadioGroupField {
        if(parameter != null){
            return new RadioGroupField(parameter?.Name, parameter?.Label, parameter?.Type, parameter?.EmptyText, parameter?.Selected, parameter?.Option, parameter?.Listeners, parameter?.Options);
        }
        return null;
    }

    private createSpinner(parameter: any): SpinnerField {
        if(parameter != null){
            return new SpinnerField(parameter?.Name, parameter?.Label, parameter?.Type, parameter?.EmptyText, parameter?.Selected, parameter?.Option, parameter?.Listeners, parameter?.Min, parameter?.Max, parameter?.Increment);
        }
        return null;
    }

    //#endregion
}